import { render, staticRenderFns } from "./v_Player_Store_Main.vue?vue&type=template&id=8ea6a2fa&scoped=true&"
import script from "./v_Player_Store_Main.vue?vue&type=script&lang=js&"
export * from "./v_Player_Store_Main.vue?vue&type=script&lang=js&"
import style0 from "./v_Player_Store_Main.vue?vue&type=style&index=0&id=8ea6a2fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea6a2fa",
  null
  
)

export default component.exports